import React from 'react';
import { useTranslation } from 'react-i18next';

import { CalculationsMenu } from '../CalculationsMenu';
import { HistoryMenuList } from './components/HistoryMenuList';

/**
 * Краткое меню истории
 */
export const History = () => {
  const { t } = useTranslation(['DeliveryForm', 'Common']);

  return (
    <CalculationsMenu
      buttonLabel={t('DeliveryForm:History')}
      linkLabel={t('DeliveryForm:GoToHistory')}
      linkHref={t('Common:HistoryLink')}
    >
      {(sectionId, isOpen) => <HistoryMenuList sectionId={sectionId} isOpen={isOpen} />}
    </CalculationsMenu>
  );
};
